import React, {useEffect, useState,useMemo} from "react";
import "./Exa.scss";
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'



function Exa() {

    const plusFive = (num) => {
        console.log("i was called!");
        return num + 5;
    };

    const [num, setNum] = useState(0);
    const [light, setLight] = useState(true);
    const numPlusFive = useMemo(() => plusFive(num), [num]);
    return (
      <div>
          <div className={light ? "light" : "dark"}>
              <div>
                  <h1>Without useMemo</h1>
                  <h2>
                      Current number: {num}, Plus five: {numPlusFive}
                  </h2>
                  <div className="button-container">
                      <button
                          onClick={() => {
                              setNum(num + 1);
                          }}
                      >
                          Update Number{" "}
                      </button>
                      <button
                          onClick={() => {
                              setLight(!light);
                          }}
                      >
                          {" "}
                          Toggle the light{" "}
                      </button>
                  </div>
              </div>
          </div>
      </div>
    )
}

export default Exa;
